export const CONTENTFUL_IDS = {
  jobSearchWidget: 'jobsSearchJobSearchWidget',
  jobCategories: 'businessArea',
  featuredJobs: 'jobsSearchFeaturedJobsWidget',
  quickJobs: 'jobsSearchQuickJobsWidget',
  countries: 'country',
}